//categorias seccion 
import { useParams } from "react-router-dom";
import CategoriasUni from "./categoriasUni";
import NavbarUni from "../../componentes/headUni";
import Marquee from "../../componentes/marquee";
import FooterPublic from "../../FooterPublic";

function CategoriasSeccion() {

    const { idSucursal, nombreSeccion } = useParams();

    return (
        <>
        <Marquee />
        <NavbarUni />
            <CategoriasUni
                idSucursal={idSucursal}
                soloSeccion={nombreSeccion}
            />
            <FooterPublic />
        </>
    );
}

export default CategoriasSeccion;